import { TEXTS } from '../texts';

export const replaceTextByErrorMessage = (message: string): string => {
  if (/already exists/.test(message)) {
    return TEXTS.DUPLICATE_MEDIAFILE_ERROR;
  }

  return message;
};
